<template>
<el-main v-loading="loading">
  <div>
    
    
    <center-nav v-if="isPay == 'true'"></center-nav>
    <div class="center-auto">
      <div class="auth-wrap">
        <div class="auth-status" v-if="isPay == 'true'">
          <img src="@/assets/img/pay_icon_pay_succeed.png" alt="" />
          <div class="success">
            <div class="success-title">付款成功</div>
            <div class="success-text">支付单号：{{ transactionId }}</div>
          </div>
        </div>
        <div class="status-text" v-if="isPay == 'true'">
          套餐版本购买成功后，请授权小程序，如果没有小程序请先注册
        </div>
        <div class="auth-box">
          <el-row>
            <el-col :span="6" class="auth-logo-div">
              <img
                class="auth-logo"
                src="@/assets/img/official/wechat_shouquanshuoming.png"
                alt=""
              />
            </el-col>
            <el-col :span="18">
              <div class="auth-title">授权说明</div>
              <div class="auth-tip">
                <div class="part-box">
                  <div class="part-circle"></div>
                  <div class="part-content">
                    <span
                      >授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</span
                    >
                  </div>
                </div>
                <div class="part-box">
                  <div class="part-circle"></div>
                  <div class="part-content">
                    <span
                      >如果你是公众号的管理员，点击下方按钮，扫码授权即可。</span
                    >
                  </div>
                </div>
                <div class="part-box">
                  <div class="part-circle"></div>
                  <div class="part-content">
                    <span
                      >如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</span
                    >
                  </div>
                </div>
                <div class="flex-button">
                  <div class="btn-box">
                    <span class="auth-btn">
                      <!--                  <a :href="authLink" target="_blank">点击开始授权公众号</a>-->
                      <iframe class="iframe" :src="authLink"></iframe>
                    </span>
                  </div>
                  <a
                    href="https://mp.weixin.qq.com/cgi-bin/registermidpage?action=index&lang=zh_CN&token="
                  >
                    <div class="button-box">还没有小程序？去注册</div>
                  </a>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!--    <div class="auth-detail" v-if="authStep == 2">-->
      <!--      <el-row>-->
      <!--        <el-col :span="13" class="left-box">-->
      <!--          <div class="detail-box">-->
      <!--            <div class="detail-div">-->
      <!--              <div class="operate-div">-->
      <!--                <div>-->
      <!--                  <img v-if="headImg" :src="headImg" alt="">-->
      <!--                  <img v-else src="../../../../assets/img/official/weishouquan.png" alt="">-->
      <!--                </div>-->
      <!--                <div class="wechat-title">{{platformName}}</div>-->
      <!--                <div><span class="wechat-btn" @click="syncTemplate()">同步消息模板</span></div>-->
      <!--                <div><span class="wechat-btn" @click="bindWechatAdmin()">绑定微信管理员</span></div>-->
      <!--              </div>-->
      <!--              <div class="link-div">-->
      <!--                <div class="link-title">-->
      <!--                  您的影票专属推广链接为：-->
      <!--                </div>-->
      <!--                <div class="link">-->
      <!--                  <a target="_blank" :href="promotionLink">{{promotionLink}}</a>-->
      <!--                </div>-->
      <!--                <div v-show="!isBasic">-->
      <!--                  <div class="link-title">-->
      <!--                    其他页面链接：-->
      <!--                  </div>-->
      <!--                  <div class="link">-->
      <!--                    <label>个人中心</label><a target="_blank" :href="personalLink">{{personalLink}}</a>-->
      <!--                    <div><div class="copy-btn" @click="copyLink(personalLink)">复制链接</div></div>-->
      <!--                  </div>-->
      <!--                  <div class="link">-->
      <!--                    <label>邀请好友</label><a target="_blank" :href="posterLink">{{posterLink}}</a>-->
      <!--                    <div><div class="copy-btn" @click="copyLink(posterLink)">复制链接</div></div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--                <div class="link-tip">-->
      <!--                  将链接放于您的公众号菜单栏中，会员点击菜单就可以专属购票页面，订单结算后您将获得订单利润分佣。-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--        <el-col :span="11" class="right-box">-->
      <!--          <div class="notice-box">-->
      <!--            <div class="auth-title">注意事项</div>-->
      <!--            <div class="auth-tip">-->
      <!--              <div class="part-box">-->
      <!--                <div class="part-circle"></div>-->
      <!--                <div class="part-content"><span>授权成功后，请先<span class="sync-template" @click="syncTemplate()">同步消息模版</span></span></div>-->
      <!--              </div>-->
      <!--              <div class="part-box">-->
      <!--                <div class="part-circle"></div>-->
      <!--                <div class="part-content"><span>不要手动去删除微信公众号生成的消息模板</span></div>-->
      <!--              </div>-->
      <!--              <div class="part-box">-->
      <!--                <div class="part-circle"></div>-->
      <!--                <div class="part-content"><span>有任何出券码的问题，及时联系客服处理</span></div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="qrcode-box">-->
      <!--              <div class="qrcode-div margin-right-10">-->
      <!--                <img class="qrcode-img" src="../../../../assets/img/official/service1.jpg" alt="">-->
      <!--                <div class="nickname">守兔票务-雪糕</div>-->
      <!--              </div>-->
      <!--              <div class="qrcode-div margin-left-10">-->
      <!--                <img class="qrcode-img" src="../../../../assets/img/official/service2.jpg" alt="">-->
      <!--                <div class="nickname">守兔票务-婷欧尼</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--    </div>-->
      <!--    <sync-template ref="template"></sync-template>-->
      <!--    <admin ref="admin"></admin>-->
    </div>
    
  </div>
  </el-main>
</template>

<script>
import SyncTemplate from "@/components/official/SyncTemplate.vue";
import Admin from "@/components/official/Admin.vue";
import {
  getUserUUID,
  getNickname,
  getPlatformUuid,
  getPlatformName,
  getHeadImg,
  getIsAuthOfficial,
  getSnaphotId,
  getIsBasic,
} from "@/utils/auth";
import official from "@/javaApi/official";
const officialModel = new official();
import centerNav from "@/components/centerNav";
export default {
  name: "Authorization",
  components: {
    SyncTemplate,
    Admin,
    centerNav,
  },
  data: function () {
    return {
      loading:true,
      isBasic: getIsBasic() === "true" ? true : false, //是否是基础版本
      listLoading: false,
      userUUID: getUserUUID(),
      bindPackage: [],
      publicInfo: [],
      authLink:
        process.env.VUE_APP_MOVIE_DOMAIN +
        "javaopen/movie/open/auth/mini-auth?userUUID=" +
        getUserUUID() +
        "&goUrl=" +
        encodeURIComponent(
          encodeURIComponent(
            "https://movie.pintoto.cn/#/pc/miniProgram/home?isAuto=1" +
              "&pitId=" +
              this.$route.query.pitId
          )
        ) +
        "&pitId=" +
        this.$route.query.pitId +
        "&buttonText=点击开始授权小程序",
      promotionLink:
        process.env.VUE_APP_MOVIE_PROMOTION_URL +
        "yp-api/movie/wx/pub-login?platformUuid=" +
        getPlatformUuid() +
        "&type=1",
      personalLink:
        process.env.VUE_APP_MOVIE_PROMOTION_URL +
        "yp-api/movie/wx/pub-login?platformUuid=" +
        getPlatformUuid() +
        "&type=personal", //个人中心链接
      posterLink:
        process.env.VUE_APP_MOVIE_PROMOTION_URL +
        "yp-api/movie/wx/pub-login?platformUuid=" +
        getPlatformUuid() +
        "&type=poster", //邀请好友链接
      authStep: getIsAuthOfficial() === "true" ? 2 : 1,
      headImg: getHeadImg(),
      platformName: getPlatformName(),
      transactionId: "", // 支付单号
      isPay: false, // 是否购买过了
      pitId: "", // 授权的套餐id
    };
  },
  created() {
    setTimeout(()=> {
      this.loading = false
    },1500)
  },
  mounted() {
    
    this.transactionId = this.$route.query.transactionId;
    // 判断是否购买了
    this.isPay = this.$route.query.isPay;
    console.log("this.isPay", this.isPay);
    // 当没有pitId时取套餐席位第一个
    if (
      this.$route.query.pitId === undefined &&
      this.$parent.packagePitList[0]
    ) {
      this.$route.query.pitId = this.$parent.packagePitList[0].id;
      // 重新在赋值一遍避免pitId变成undefined
      // goUrl测试和正式环境上前线需要设置对应的域名
      this.authLink =
        process.env.VUE_APP_MOVIE_DOMAIN +
        "javaopen/movie/open/auth/mini-auth?userUUID=" +
        getUserUUID() +
        "&goUrl=" +
        encodeURIComponent(
          encodeURIComponent(
            "https://movie.pintoto.cn/#/pc/miniProgram/home?isAuto=1"
          )
        ) +
        "&pitId=" +
        this.$route.query.pitId +
        "&buttonText=点击开始授权小程序";
        
        // this.authLink =
        // process.env.VUE_APP_MOVIE_DOMAIN +
        // "javaopen/movie/open/auth/mini-auth?userUUID=" +
        // getUserUUID() +
        // "&goUrl=" +
        // encodeURIComponent(
        //   encodeURIComponent(
        //     "http://movie-test.taototo.cn/#/pc/miniProgram/home?isAuto=1"
        //   )
        // ) +
        // "&pitId=" +
        // this.$route.query.pitId +
        // "&buttonText=点击开始授权小程序";
    }
    // 判断是否是商户
    localStorage.removeItem("isMerchant");
  },
  methods: {
    syncTemplate: function () {
      this.$refs.template.init();
      //https://test.taototo.cn/movie/api/template/addOneTemplate?platformUUID=xxxx
      console.log("同步消息模板");
    },
    bindWechatAdmin: function () {
      this.$refs.admin.init();
      //https://test.taototo.cn/movie/api/dis.user/bindAdmin?adminPlatform=XXXX ---这个是绑定微信管理员 - 扫码绑定（获取二维码链接）
      console.log("绑定微信管理员");
    },
    copyLink: function (link) {
      var that = this;
      this.$copyText(link).then(
        function (e) {
          that.$Message.success("复制成功");
        },
        function (e) {
          that.$Message.error("复制失败,请升级浏览器版本！");
        }
      );
    },
    bindBtn() {
      console.log("debug:________________bindBtn______________");
      localStorage.removeItem("isMerchant");
    },
  },
};
</script>
<style>
html {
  background: #f5f5fa;
}
</style>
<style scoped lang="less">
@media screen and (max-width: 1750px) {
  .center-auto {
    margin: 20px 60px !important;
  }
}
.center-auto {
  margin: 20px 260px;
  background: #ffffff;
  height: 100%;
  //box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 6%);
  border-radius: 8px;
}
.margin-left-10 {
  margin-left: 10px;
}
.margin-right-10 {
  margin-right: 10px;
}
.center-auto .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}
.auth-wrap .auth-box {
  padding: 60px 214px;
}
.auth-wrap .auth-box .auth-logo-div {
  padding-right: 30px;
}
.auth-wrap .auth-box .auth-logo {
  width: 100%;
  padding-top: 30px;
}
.auth-wrap .auth-box .auth-title,
.auth-detail .auth-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}
.auth-wrap .auth-box .auth-tip,
.auth-detail .auth-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #666666;
  margin-top: 10px;
}
.auth-wrap .auth-box .part-box,
.auth-detail .part-box {
  display: flex;
  flex-direction: row;
  padding: 4px 0;
}
.auth-wrap .auth-box .part-circle,
.auth-detail .part-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #d63036;
  margin: 5px 8px 5px 0;
}
.auth-detail .part-circle {
  background: #999999;
}
.auth-wrap .auth-box .part-content,
.auth-detail .part-content {
  width: 90%;
}
.auth-wrap .auth-box .btn-box {
  padding-top: 5px;
  background: #ff8622;
  margin-right: 20px;
}
.auth-wrap .auth-box .btn-box .auth-btn {
  font-family: Alibaba-PuHuiTi-R;
  background: #ff8622;
  border-radius: 2px;
  color: #ffffff;
  //padding: 20px;
}
.auth-wrap .auth-box .btn-box .auth-btn a {
  color: #ffffff;
}
.auth-detail {
  padding-top: 30px;
  min-width: 900px;
}
.auth-detail .left-box {
  padding-right: 20px;
}
.auth-detail .left-box .detail-box {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  min-width: 440px;
}
.auth-detail .left-box .detail-box .detail-div {
  padding: 20px 20px 160px 20px;
}
.auth-detail .left-box .detail-box .detail-div .operate-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #ff8622;
  padding: 10px 0;
}
.auth-detail .left-box .detail-box .detail-div .operate-div img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.auth-detail .left-box .detail-box .detail-div .operate-div .wechat-title {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #666666;
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}
.auth-detail .left-box .detail-box .detail-div .operate-div .wechat-btn {
  border: 1px solid #ff8622;
  padding: 6px 15px;
  cursor: pointer;
}
.auth-detail .left-box .detail-box .detail-div .link-div {
  padding-top: 20px;
}
.auth-detail .left-box .detail-box .detail-div .link-title {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #222222;
}
.auth-detail .left-box .detail-box .detail-div .link {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #3d9efc;
  padding: 6px 0;
  display: flex;
}
.auth-detail .left-box .detail-box .detail-div .link label {
  width: 100px;
  color: #222222;
}
.auth-detail .left-box .detail-box .detail-div .link-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #666666;
}
.auth-detail .right-box {
  padding-left: 20px;
}
.auth-detail .right-box .notice-box {
  min-width: 380px;
}
.auth-detail .right-box .notice-box .qrcode-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
}
.auth-detail .right-box .notice-box .qrcode-box .qrcode-div {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  width: 180px;
  padding: 20px;
}
.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .qrcode-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
}
.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .nickname {
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #222222;
}
.auth-detail .part-content .sync-template {
  color: #ff4f76;
  padding-left: 5px;
  cursor: pointer;
}
.copy-btn {
  border: 1px solid #ff8622;
  padding: 6px 15px;
  cursor: pointer;
  color: #ff8622;
  white-space: nowrap;
}
.auth-status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
  .success {
    margin-left: 20px;
    .success-title {
      font-size: 24px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #51c456;
      line-height: 22px;
    }
  }
}
.status-text {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #333333;
  line-height: 22px;
  text-align: center;
  margin-top: 40px;
}
.button-box {
  width: 178px;
  height: 42px;
  border-radius: 2px;
  border: 1px solid #ff8622;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ff8622;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
}
.flex-button {
  display: flex;
  align-items: center;
}
.iframe {
  border: none;
  height: 30px;
}
.success-text {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/auto/index.vue